import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class MultiplePhoneField extends Component {
    static propTypes = {
        val: PropTypes.string,
        phoneType: PropTypes.number,
        numberId: PropTypes.string.isRequired,
        typeId: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : '',
        phoneType : ''
    };

    componentDidMount() {
        // let mask = [{ "mask": "+##(###) ###-####"}, { "mask": "(+###) #-### ####"}]; //default mask
        // // eslint-disable-next-line
        // if(this.props.phoneType != undefined) {
        //     if (parseInt(this.props.phoneType, 10) === 1) { //mobile
        //         mask = [{ "mask": "(###) ###-####"}, { "mask": "(+###) # ### ####"}];
        //     } else {
        //         mask = [{ "mask": "###-####"}, { "mask": "(###) ### ####"}];
        //     }
        // }

        // $('.phoneInput[data-index='+this.props.index+']').inputmask("text", {
        //     mask: mask,
        //     autoUnmask: true,
        //     greedy: false, 
        //     definitions: { '#': { validator: "[0-9]", cardinality: 1}},
        //     oncomplete : (e) => {
        //         this.setState({
        //             val : e.target.value,
        //         }, (e) => {
        //             let phoneNumber = this.state.val;

        //             this.props.updatePhoneArray(this.props.index, phoneNumber, this.state.phoneType);
        //         });
        //     },
        //     oncleared : (e) => {
        //         $('.phoneInput[data-index='+this.props.index+']').inputmask('remove');
        //     }
        // })

        this.setState({
            val: this.props.val,
            phoneType: this.props.phoneType
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val,
            phoneType: nextProps.phoneType
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handlePhoneTypeChange = (e) => {
        this.setState({
            phoneType: parseInt(e.target.value, 10)
        }, () => {
            let phoneType = this.state.phoneType;

            this.props.updatePhoneArray(this.props.index, this.state.val, phoneType);
        });

        let mask = [{ "mask": "+##(###) ###-####"}, { "mask": "(+###) # ### ####"}]; //default mask
        if (parseInt(e.target.value, 10) === 1) { //mobile
            mask = [{ "mask": "+##(###) ###-####"}, { "mask": "(+###) # ### ####"}];
        } else {
            mask = [{ "mask": "###-####"}, { "mask": "(###) ### ####"}];
        }
        $('.phoneInput[data-index='+this.props.index+']').inputmask("text", {
            mask: mask,
            autoUnmask: true,
            showMaskOnHover: false,
            greedy: false, 
            definitions: { '#': { validator: "[0-9]", cardinality: 1}},
            oncomplete : (e) => {
                this.setState({
                    val : e.target.value,
                }, (e) => {
                    let phoneNumber = this.state.val;

                    this.props.updatePhoneArray(this.props.index, phoneNumber, this.state.phoneType);
                });
            }
        })
    }

    handleOnChangeInput = (e) => {
        // console.log(e);
        // e.preventDefault();
        let reg = new RegExp(/[- +()]*[0-9][- +()0-9]*$/);
        let valid = reg.test(e.target.value);
        let mask = '';

        if(valid && e.target.value.length >= 1)
        {
            if(e.target.value.length >= 3)
            {
                if(e.target.value === '+63')
                {
                    mask = '+##(###)###-####';
                    
                }
                if(e.target.value === '+230')
                {
                    mask = '(+###) #-### ####';
                    
                }

                $('.phoneInput[data-index='+this.props.index+']').inputmask("text", {
                    mask: mask,
                    autoUnmask: true,
                    oncomplete : (e) => {
                        this.setState({
                            val : e.target.value,
                        }, (e) => {
                            let phoneNumber = this.state.val;

                            this.props.updatePhoneArray(this.props.index, phoneNumber, this.state.phoneType);
                        });
                    },
                    oncleared : (e) => {
                        $('.phoneInput[data-index='+this.props.index+']').inputmask('remove');
                    }
                }) 
            }
            
        }

        this.setState({
            val : e.target.value,
        }, (e) => {
            let phoneNumber = this.state.val;

            this.props.updatePhoneArray(this.props.index, phoneNumber, this.state.phoneType);
        });
    }

    render() {
        var className = this.state.val ? 'form-control phoneInput edited' : 'form-control phoneInput';

        var buttonColor = "red removePhone"
        var buttonClassname = "fa fa-times removePhone";

        if (this.props.index === this.props.totalIndex - 1) {
            buttonColor = "blue addPhone";
            buttonClassname = 'fa fa-plus addPhone';
        }

        // console.log(this.state)

        return (
            <div className="row perContainer" data-index={this.props.index}>
                <div className="col-md-6 col-xs-5 col-sm-7">
                    <div className="form-group form-md-line-input form-md-floating-label" >
                        
                   
                                <input type="text" className={className} data-index={this.props.index}
                                   name={this.props.numberId}
                                   value={this.state.val} 
                                   onChange={this.handleOnChangeInput} />
                                <label htmlFor={this.props.id}>{this.props.label}</label>
                                <span className="help-block sr-only">Specify your country code (Optional)</span>
                    </div>
                </div>
                <div className="col-md-5 col-xs-5 col-sm-3">
                    <div className="form-group form-md-line-input form-md-floating-label" >
                            <select name={this.props.typeId} className="form-control" value={this.props.phoneType}
                                    onChange={this.handlePhoneTypeChange} >
                                <option value="1">Mobile</option>
                                <option value="2">Home</option>
                                <option value="3">Work</option>
                                <option value="4">Fax</option>
                            </select>
                            <label className="control-label">&nbsp;</label>
                    </div>
                </div>
                <div className="col-md-1 col-xs-1 col-sm-2 text-center" style={{marginTop: '20px'}}>
                    <span className="input-group-btn btn-right">
                        <a href="#" className={"btn btn-circle btn-icon-only " + buttonColor}>
                            <i className={buttonClassname}></i>
                        </a>
                    </span>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/MultiplePhoneField.js
 **/